import { render, staticRenderFns } from "./EndCall.vue?vue&type=template&id=73047cd0&"
import script from "./EndCall.vue?vue&type=script&lang=js&"
export * from "./EndCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports